import React, {Fragment, useEffect} from "react";
import CircularProgressbar from "react-circular-progressbar";
import {Link, withRouter} from "react-router-dom";
import moment from "moment";

import AppContainer from "../AppContainer/AppContainer";
import useAppState from "../../common/StateMachine/useAppState";
import Button from "../../common/Button/Button";

import "./job-details.scss";
import {useTranslation} from "react-i18next";
import {InfoCard} from "../Reusable/InfoCard";

const JobDetails = props => {
    const jobsState = useAppState("jobs");
    const [t] = useTranslation();

    const jobDetail = jobsState.state.jobDetail;
    const {plasticType, userCommitment} = jobDetail;

    useEffect(() => {
        jobsState.getJob(props.match.params.jobId);
    }, []);

    return (
        <AppContainer>
            {jobDetail.id && (
                <Fragment>
                    <div className="header-container">
                        {/*<div className="pt-16 justify-center align-center">
                            <div className="crumb-nav"
                                 style={{display: "flex", justifyContent: "flex-start"}}>
                                <Link to="/jobs/my-jobs">{t("myJobs")}</Link>{" "}
                                <Link to="/jobs/browse-new">{t("jobs")}</Link>{" "}
                                <span>{t(plasticType.name)}</span>
                            </div>
                        </div>*/}
                        <div className="flex justify-center align-center"
                             style={{"padding-bottom": "32px", "padding-top": "64px"}}>
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <div className="job-details-image">
                                    <img src={plasticType.imagePath} alt="product"/>
                                </div>
                                <div className="job-details-content">
                                    <h1>{t(plasticType.name)}</h1>
                                    <span>{t("$")}{jobDetail.pricePerKg.toFixed(2)}/kg</span>
                                    <img src="/icon-clock.svg" alt=""/>
                                    <span>
                                    {moment(jobDetail.dueByLocal).format("DD MMM YYYY")}
                                    </span>
                                    <img src="/icon-location.svg" alt=""/>
                                    <span>{jobDetail.assignedSites[0].name}</span>
                                    {userCommitment.latestUserCommitment && (
                                        <div className="job-card-progress">
                                            <CircularProgressbar
                                                strokeWidth={14}
                                                percentage={
                                                    ((userCommitment.totalAmountCollected + 0.01) / userCommitment.totalAmountCommitted) * 100
                                                }
                                            />
                                            <span>
                                            {userCommitment.totalAmountCollected}kg/ {userCommitment.totalAmountCommitted}kg {t("toCollect")}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="jobs-list-container pad-top justify-center">
                        <h4>{t("jobDetail")}</h4>
                        {/*JobID*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("jobId")}:`}
                                description={`#${jobDetail.id}`}/>
                        </div>
                        {/*Price Per Kg*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("price")}:`}
                                      description={`${t("$")}${jobDetail.pricePerKg.toFixed(2)}/kg`}/>
                        </div>
                        {/*Your commitment */}
                        {
                            userCommitment.latestUserCommitment && (
                                <div className="details-center-container">
                                    <InfoCard title={`${t("yourCommitment")}`} description={`${userCommitment.totalAmountCommitted} kg`}/>
                                </div>
                            )
                        }
                        {/*You will Earn*/}
                        {
                            userCommitment.latestUserCommitment && (
                                <div className="details-center-container">
                                    <InfoCard title={`${t("youWillEarn")}:`}
                                              description={`${t("$")}${(jobDetail.pricePerKg * userCommitment.totalAmountCommitted).toFixed(2)}`}/>
                                </div>
                            )
                        }

                        {/*Dropoff Date*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("dropOffDate")}:`}
                                      description={moment(jobDetail.dueByLocal).format("DD MMM YYYY")}/>
                        </div>

                        {/*Drop Off Location*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("dropOffLocation")}:`}
                                      description={jobDetail.assignedSites[0].name}/>
                        </div>

                        <h4>{t("whatToCollect")}</h4>
                        {/*Plastic Type*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("plasticType")}:`}
                                      description={t(plasticType.name)}/>
                        </div>

                        {/*Number*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("recyclingNumber")}:`}
                                      description={plasticType.resinID}/>
                        </div>

                        {/*Colour*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("colour")}:`}
                                      description={jobDetail.plasticColourName}/>
                        </div>

                        {/*Cleaned*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("cleaned")}:`}
                                      description={jobDetail.cleaned ? t("yes") : t("no")}/>
                        </div>

                        {/*Minimum Collection*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("minimumCollection")}:`}
                                      description={`1 kg`}/>
                        </div>

                        {/*Other Details*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("otherDetails")}:`}
                                      description={(jobDetail.otherDetails != null) ? t(jobDetail.otherDetails) : ""}/>
                        </div>
                        {/*Other Notes*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("notes")}:`}
                                    description={(jobDetail.notes != null) ? jobDetail.notes : ""} />
                        </div>

                        {/*Buttons*/}
                        <div className="jobs-list flex justify-center align-center">
                            <div>
                                {userCommitment.latestUserCommitment && (
                                    <Link to={`/qualitycheck/${props.match.params.jobId}`}>
                                        <Button className="mt-32" text={t("readyToDeliver")}/>
                                    </Link>
                                )}
                            </div>
                        </div>
                        <div className="jobs-list flex justify-center align-center">
                            <div>
                                <Link to={`/jobs/job-commit/${props.match.params.jobId}`}>
                                    <Button
                                        className="mt-32 mb-8"
                                        text={
                                            userCommitment.latestUserCommitment
                                                ? t("changeAmountToCollect")
                                                : t("selectAmountToCollect")
                                        }
                                    />
                                </Link>
                            </div>
                        </div>
                        <div className="jobs-list flex justify-center align-center">
                            <div>
                                <Link to="/jobs/browse-new">
                                    <Button secondary className="mb-32" text={t("backToBrowse")}/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )}
        </AppContainer>
    );
};

export default withRouter(JobDetails);
